module.exports = __webpack_public_path__ + "img/mat_213.e553446f.png";